<div class="panel no-application-bar">
  <div>
    <div style='letter-spacing: 14px;
    font-weight: 300;
    font-size: 2.5rem;
    color: #1e88e5;
    text-transform: uppercase;'>Oncoscape</div>
    <div style='font-size: 1rem; text-transform: uppercase; color: #666; letter-spacing: 5px; padding-top: 20px;'>Accelerate your research</div>

    <div style='font-size: 1rem; color: #000; font-weight: 500; padding-top: 20px; max-width: 1200px;'>
      Oncoscape is a powerful, interactive data visualization tool for both molecular and clinical discovery. 
      See a preview of our new Oncoscape Components system, 
      or see some publication support sites we've created using the Oncoscape Classic platform. <br /><br />
      <a href=mailto:contact-onc@fredhutch.org>Contact us at contact-onc@fredhutch.org</a> for more information, request a demo, gain early access, or see how we can help you get a free, customized solution working for you very quickly.
    </div>    
  </div>

  <div class="section-container" style="margin-top: 40px;">
    <h2 class="section-title">Preview Oncoscape Components&nbsp;&nbsp;<img src="assets/landing/components_toolicons.png" alt="Oncoscape Components Tools" style="height: 36px; "></h2>
    <div fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="40px">
      <img src="assets/landing/components_001.png" alt="Preview" style="width: 420px; ">
      <div fxLayout="column" style="margin-top: 0;">
        <div class="preview-text">

Oncoscape Components is a new system for building custom, interactive visualizations of cancer data. Building on earlier breakthrough visualization work from the Oncoscape team, 
it offers a high-performance, highly interactive and synchronized experience for exploring both clinical and molecular data, and where they intersect. It's easy to
create cohorts from a 2D or 3D dimension reduction landscape (such as UMAP), heatmaps, survival curves, volcano plots, bar charts, and more. And once you make a selection (of patients, genes, or other features), all other 
visualizations will update automatically to show the selected data.


        </div>
        <button mat-raised-button color="primary" style="margin-top: 20px; width: fit-content;" onclick="window.location.href='https://oncoscape-projects.vercel.app/sttr-retreat-2025'">Learn More</button>
      </div>
    </div>
  </div>

  <div class="section-container" style="margin-top: 60px;">
    <h3 class="section-title">Some Publications Using Oncoscape Classic</h3>
    
    <div class="publication-item" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="40px" style="margin-top: 30px;">
      <a href="https://oncoscape.v3.sttrcancer.org/redirect4.html?protocol=https&server=oncoscape.sttrcancer.org:&project=medulloblastomaumap" target="_blank" rel="noopener">
        <img src="assets/landing/pub_medepn.png" alt="Ependymoma and Medulloblastoma" style="width: 150px;">
      </a>
      <div fxLayout="column">
        <a href="https://oncoscape.v3.sttrcancer.org/redirect4.html?protocol=https&server=oncoscape.sttrcancer.org:&project=medulloblastomaumap" target="_blank" rel="noopener" style="text-decoration: none;">
          <h3 class="publication-title">Medulloblastoma and Ependymoma</h3>
        </a>
        <div class="publication-text">
          A landscape was built using transcriptomic analysis of 1,258 medulloblastomas and ependymomas, and including unified landscape to explore gene expression, signaling pathways, gene fusions, and copy number variations.
          This landscape reveals novel insights about distinct clustering patterns, including two primary ependymoma compartments, EPN-E1 and EPN-E2, each with specific gene fusions and molecular signatures. In medulloblastoma, they achieved precise stratification of Group 3/4 tumors by subtype and in SHH tumors by patient age.<br />
          <a href="https://www.biorxiv.org/content/10.1101/2024.10.21.619495v1"  target="_blank" rel="noopener">

          Transcriptomic Landscape Identifies Two Unrecognized Ependymoma Subtypes and Novel Pathways in Medulloblastoma

          </a><br />
          Thirimanne, et al, PREPRINT, 2024, https://doi.org/10.1101/2024.10.21.619495
        </div>
      </div>
    </div>

    <div class="publication-item" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="40px" style="margin-top: 30px;">
      <a href="https://oncoscape.v3.sttrcancer.org/redirect4.html?protocol=https&server=oncoscape.sttrcancer.org:&project=meningiomaumap94" target="_blank" rel="noopener">
        <img src="assets/landing/pub_meningioma.png" alt="Meningioma" style="width: 150px;">
      </a>
      <div fxLayout="column">
        <a href="https://oncoscape.v3.sttrcancer.org/redirect4.html?protocol=https&server=oncoscape.sttrcancer.org:&project=meningiomaumap94" target="_blank" rel="noopener" style="text-decoration: none;">
          <h3 class="publication-title">Meningioma</h3>
        </a>
        <div class="publication-text">
          Current WHO grading of meningiomas doesn't always spot the most dangerous cases. Thirimanne et al combined 13 RNA-seq datasets to create a gene expression landscape of 1,298 tumors. 
           This map revealed subtypes with distinct biological traits, and tumor location on the map was linked to how quickly the meningioma recured. Their paper also describes an algorithm that places new patients on the map, using nearby cases to predict outcomes. <br />
          <a href="https://www.sciencedirect.com/science/article/pii/S2666979X24001320"  target="_blank" rel="noopener">

          Meningioma Transcriptomic Landscape Demonstrates Novel Subtypes With Regional Associated Biology and Patient Outcome
          </a><br />
          Thirimanne, et al, Cell Genomics, Volume 4, Issue 6, 2024, 100566, https://doi.org/10.1016/j.xgen.2024.100566.

        </div>
      </div>
    </div>

    <div class="publication-item" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="40px" style="margin-top: 30px;">
      <a href="https://oncoscape.v3.sttrcancer.org/redirect4.html?protocol=https&server=oncoscape.sttrcancer.org:&project=bulkrnaseqbrainumap" target="_blank" rel="noopener">
        <img src="assets/landing/pub_brainumap.png" alt="BrainUMAP" style="width: 150px; height: 150px; object-fit: cover;">
      </a>
      <div fxLayout="column" style="margin-top: 0;">
        <a href="https://oncoscape.v3.sttrcancer.org/redirect4.html?protocol=https&server=oncoscape.sttrcancer.org:&project=bulkrnaseqbrainumap" target="_blank" rel="noopener" style="text-decoration: none;">
          <h3 class="publication-title" style="margin-top: 0;">BrainUMAP</h3>
        </a>
        <div class="publication-text">
          Arora et al assembled a reference Brain-UMAP including 702 adult gliomas, 802 pediatric tumors and 1409 healthy normal brain samples, which can be utilized to investigate the wealth of information obtained from combining several publicly available datasets to study a single organ site. Normal brain regions and tumor types create distinct clusters and because the landscape is generated by RNA-Seq, comparative gene expression profiles and gene ontology patterns are readily evident.
          <a href="https://www.nature.com/articles/s41598-023-31180-z"  target="_blank" rel="noopener">

          Visualizing Genomic Characteristics Across an RNA-Seq Based Reference Landscape of Normal and Neoplastic Brain
          </a><br />
          Arora, et al, Scientific Reports 13(1), 2023, http://dx.doi.org/10.1038/s41598-023-31180-z

        </div>
      </div>
    </div>

  </div>

  <footer class='landing-footer'>
    <div fxLayout='row' fxLayout.sm='column' fxLayout.xs='column' fxLayoutAlign="space-between center">
      <div class="footer-text">
        Fred Hutch 1100 Fairview Ave. N.
        <br /> P.O. Box 19024, Seattle, WA 98109
        <br />
        <a style='color:#fff; text-decoration: none;' href="/assets/terms.html">Terms and Conditions</a>
      </div>
      <div>
        <div class='section-footer'>
          <span class='footer-text'>
            <a href="https://twitter.com/oncoscape" target="_blank">
              <i class="fa fa-twitter-square fa-3x social"></i>
            </a>
            <a href="https://www.instagram.com/oncoscape/" target="_blank">
              <i class="fa fa-instagram fa-3x social"></i>
            </a>
            <a href="https://www.facebook.com/STTRCancer/" target="_blank">
              <i class="fa fa-facebook-square fa-3x social"></i>
            </a>
            <a href="mailto:contact-onc@fredhutch.org" target="_blank">
              <i class="fa fa-envelope-square fa-3x social"></i>
            </a>
          </span>
        </div>
      </div>
    </div>
  </footer>
</div>
